import { useState } from "react";
import Header from "../../layouts/Header";
import Sidebar from "../../layouts/Sidebar";
import AddForm from "./form";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const AddDocument = () => {
  const [menu, setMenu] = useState(false);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  const { uuid } = useParams();
  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={toggleMobileMenu} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="card mb-0">
            <div className="card-body">
              <div className="page-header">
                <div className="content-page-header">
                  <h5>Add Document</h5>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group-item">
                    <AddForm toggleMobileMenu={toggleMobileMenu} id={uuid} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddDocument;
